var DeleteAssessmentCredentialModalController = /** @class */ (function () {
    function DeleteAssessmentCredentialModalController() {
        // this.companyId = this.resolve.companyId;
        // this.buId = this.resolve.buId;
        // this.testOwnerEmail = this.resolve.testOwnerEmail;
        // this.assessmentId = this.resolve.assessmentId;
        // this.context = this.resolve.context;
        // this.isDeleteCredential = this.resolve.isDeleteCredential;
    }
    DeleteAssessmentCredentialModalController.prototype.$onInit = function () {
        this.companyId = this.resolve.companyId;
        this.buId = this.resolve.buId;
        this.testOwnerEmail = this.resolve.testOwnerEmail;
        this.assessmentId = this.resolve.assessmentId;
        this.context = this.resolve.context;
        this.isDeleteCredential = this.resolve.isDeleteCredential;
        this.title = this.isDeleteCredential ? 'Assessment Credential Deletion' : 'Remove Assessment';
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    DeleteAssessmentCredentialModalController.prototype.delete = function () {
        this.callbackObject.callbackType = 'delete';
        this.closeModal();
    };
    DeleteAssessmentCredentialModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    DeleteAssessmentCredentialModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return DeleteAssessmentCredentialModalController;
}());
// import * as TEMPLATE from './delete-assessment-credential-modal.html';
import * as TEMPLATE from 'raw-loader!./delete-assessment-credential-modal.html';
export var DeleteAssessmentCredentialModalComponent = {
    selector: 'deleteAssessmentCredentialModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: DeleteAssessmentCredentialModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/deleteAssessmentCredentialModal/delete-assessment-credential-modal.html'
    }
};
//# sourceMappingURL=delete-assessment-credential-modal.component.js.map